// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3GEUb","colMaxWidth":"Table_colMaxWidth__1wYz7"};